import React from 'react';
import PropTypes from 'prop-types';
import { LiveStatsCard } from 'components/live-stats';

const LiveStatsPost = ({ post }) => {
    let parsedStats = null;

    if (post.card && post.card.dataJson) {
        try {
            parsedStats = JSON.parse(post.card.dataJson);
        } catch (error) {
            console.log(error.message);
        }
    }

    if (parsedStats) {
        post.card = { ...post.card, ...parsedStats };
    }

    return <LiveStatsCard model={post.card} />;
};

LiveStatsPost.propTypes = {
    id: PropTypes.string,
    type: PropTypes.string,
    card: PropTypes.object,
    datePublished: PropTypes.string,
};

export default LiveStatsPost;
